import debounce from "lodash/debounce";

export default {
    data() {
        return {
            phoneNumberInvalid: false,
            juleicaInvalid: false,
            juleicaCardNumberDoesntMatchWithContact: false,
            ibanInvalid: false,
            cancelCheckIban: null,
            cancelCheckPhone: null,
            cancelCheckJuleica: null,
            pendingCheckIban: false,
            pendingCheckPhone: false,
            pendingCheckJuleica: false
        }
    },
    computed: {
        checkedCustomRules() {
            if (!this.uncheckedRules) return {}
            let checkedRules = this.$cloneDeep(this.uncheckedRules)
            if (checkedRules.hasOwnProperty('ibanInvalid')) {
                this.$set(checkedRules, 'pending', this.pendingCheckIban)
                checkedRules.ibanInvalid = this.ibanInvalid && !this.pendingCheckIban
            }
            if (checkedRules.hasOwnProperty('phoneInvalid')) {
                this.$set(checkedRules, 'pending', this.pendingCheckPhone)
                checkedRules.phoneInvalid = this.phoneNumberInvalid && !this.pendingCheckPhone
            }
            if (checkedRules.hasOwnProperty('juleicaInvalid')) {
                this.$set(checkedRules, 'pending', this.pendingCheckJuleica)
                checkedRules.juleicaInvalid = this.juleicaInvalid && !this.pendingCheckJuleica
                checkedRules.juleicaCardNumberDoesntMatchWithContact = this.juleicaCardNumberDoesntMatchWithContact && !this.pendingCheckJuleica
            }
            return checkedRules
        }
    },
    methods: {
        checkCustomRulesFor(value) {
            if (!this.uncheckedRules) return
            if (this.uncheckedRules.hasOwnProperty('ibanInvalid')) {
                this.checkIban(value)
            }
            if (this.uncheckedRules.hasOwnProperty('phoneInvalid')) {
                this.checkPhone(value)
            }
            if (this.uncheckedRules.hasOwnProperty('juleicaInvalid')) {
                this.checkJuleica(value)
            }
        },
        checkIban(iban) {
            this.cancelCheckIban && this.cancelCheckIban();
            this.checkIbanDebounced(iban)
        },
        checkIbanDebounced: debounce(async function (iban) {
            this.pendingCheckIban = true
            this.cancelCheckIban = this.$axios.CancelToken?.source();
            try {
                let result = await this.$axios.post(
                    this.$apiRoute('api.registration.validation'),
                    {
                        type: "iban",
                        data: iban
                    },
                    {
                        cancelToken: this.cancelCheckIban?.token
                    }
                )
                this.ibanInvalid = !result.data.isValid
            } catch (e) {
                console.error(e)
            }
            this.pendingCheckIban = false
        }, 700),
        checkPhone(number) {
            this.cancelCheckPhone && this.cancelCheckPhone();
            this.checkPhoneDebounced(number)
        },
        checkPhoneDebounced: debounce(async function (number) {
            this.pendingCheckPhone = true
            this.cancelCheckPhone = this.$axios.CancelToken?.source();
            try {
                let result = await this.$axios.post(
                    this.$apiRoute('api.registration.validation'),
                    {
                        type: "phone",
                        data: number
                    },
                    {
                        cancelToken: this.cancelCheckPhone?.token
                    }
                )
                this.phoneNumberInvalid = !result.data.isValid
            } catch (e) {
                console.error(e)
            }
            this.pendingCheckPhone = false
        }, 700),
        checkJuleica(number) {
            this.cancelCheckJuleica && this.cancelCheckJuleica();
            this.checkJuleicaDebounced(number)
        },
        checkJuleicaDebounced: debounce(async function (number) {
            this.pendingCheckJuleica = true
            this.cancelCheckJuleica = this.$axios.CancelToken?.source();
            try {
                let result = await this.$axios.post(
                    this.$apiRoute('api.registration.validation'),
                    {
                        type: "juleica",
                        data: number,
                        person: this.person
                    },
                    {
                        cancelToken: this.cancelCheckJuleica?.token
                    }
                )
                this.juleicaInvalid = !result.data.isValid
                this.juleicaCardNumberDoesntMatchWithContact = !result.data.data.matchesWithContact
            } catch (e) {
                console.error(e)
            }
            this.pendingCheckJuleica = false
        }, 700)
    }
}
